import React from "react";

const Noti = ({ m, type, h }) => {
  const bg = type === "error" ? h.rd : type === "warn" ? h.wn : h.gn;
  return <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", background: bg, color: "#fff", padding: "10px 24px", borderRadius: 12, fontSize: 13, fontWeight: 600, zIndex: 999, boxShadow: "0 4px 20px rgba(0,0,0,.2)", maxWidth: "90%", textAlign: "center" }}>{m}</div>;
};

export default Noti;
